import { gql } from '@apollo/client/core';
import carPrice from '../../../gqlCommon/graphql/fragments/carPrice';
import trim from '../../../gqlCommon/graphql/fragments/trim';
import standardFeatures from '../../../gqlCommon/graphql/fragments/standardFeatures';
import simpleSpecPackEngineAttributes from '../../../gqlCommon/graphql/fragments/simpleSpecPackEngineAttributes';
import bodyStyleAttributes from '../../../gqlCommon/graphql/fragments/bodyStyleAttributes';
import variantName from '../../../gqlCommon/graphql/fragments/variantName';
import simpleSpecPackPrices from '../../../gqlCommon/graphql/fragments/simpleSpecPackPrices';
import modelAttributes from '../../../gqlCommon/graphql/fragments/modelAttributes';

const simpleSpecPackTrimLevel = {
  GET_SIMPLE_SPEC_PACK_TRIM_LEVEL: gql`
    ${carPrice.CAR_PRICE}
    ${standardFeatures.STANDARD_FEATURES}
    ${trim.TRIM}
    ${simpleSpecPackEngineAttributes.SIMPLE_SPEC_PACK_ENGINE}
    ${bodyStyleAttributes.BODY_STYLE_ATTRIBUTES}
    ${variantName.VARIANT_NAME}
    ${simpleSpecPackPrices.SIMPLE_SPEC_PACK_PRICES}
    ${modelAttributes.MODEL_ATTRIBUTES}
    query GetSimpleSpecPackTrimLevel(
      $filters: Filters
      $financeInput: FinanceInput
      $financeProductId: FinanceProductId
      $postCode: String
      $insuranceFormInput: InsuranceFormInput
      $dataLayer: Boolean!
    ) {
      specPacks(filters: $filters, financeInput: $financeInput) {
        specPack {
          code
          attributes {
            shortname
            fullSpecsUrl
            oemcode
            marketingcategory
          }
        }
        carConfig(
          financeProductId: $financeProductId
          financeInput: $financeInput
          postCode: $postCode
          insuranceFormInput: $insuranceFormInput
        ) {
          car {
            attributes {
              vehicleDisplayName
              specDescription
              priceLabel
            }
            trim @include(if: $dataLayer) {
              ...Trim
            }
            code
            variant @include(if: $dataLayer) {
              ...VariantName
            }
            engine @include(if: $dataLayer) {
              ...SimpleSpecPackEngine
            }
            model {
              attributes {
                label
                oemcode
                ...ModelAttributes @include(if: $dataLayer)
              }
            }
            keyFeatures {
              id
              label
              shortname
              shortDescription
              longDescription
              code
              attributes {
                disclaimer
              }
            }
            standardFeatures @include(if: $dataLayer) {
              ...StandardFeatures
            }
            bodyStyle @include(if: $dataLayer) {
              ...BodyStyleAttributes
            }
          }
          prices @include(if: $dataLayer) {
            ...SimpleSpecPackPrices
          }
        }
      }
    }
  `,
};

export default simpleSpecPackTrimLevel;
